import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Container, Row, Col, Badge } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const data = [
  { name: "Figma", value: 80 },
  { name: "Sketch", value: 41 },
];

const COLORS = {
  Figma: "#6366F1", // Blue/indigo
  Sketch: "#10B981", // Green
};

const GoalsMetChart = () => {
  const total = data.reduce((sum, entry) => sum + entry.value, 0);

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    name,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius + 30;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill={COLORS[name]}
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize="14"
        fontWeight="400"
      >
        {name}
      </text>
    );
  };

  return (
    <div className="goals-met-chart">
      <h2 className="font-20 font-weight-s-bold heading-color ps-5 pb-2 border-bottom">Goals Met</h2>
      <div
        className="position-relative"
        style={{
          width: "100%",
          height: "250px",
          maxWidth: "400px",
          margin: "0 auto",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[entry.name]} />
              ))}
            </Pie>

            {/* Centered total inside donut */}
            <text
              x="50%"
              y="50%"
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="22"
              fontWeight="600"
              fill="#111827"
            >
              {total}
            </text>
          </PieChart>
        </ResponsiveContainer>
      </div>
      {/* Legend */}
      <Row className="justify-content-center mt-4">
        <Col xs="auto">
          <div className="d-flex gap-4">
            <div className="d-flex align-items-center">
              <div
                className="rounded-circle me-2"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: COLORS.Figma,
                }}
              ></div>
              <span className="text-muted small">Figma</span>
            </div>
            <div className="d-flex align-items-center">
              <div
                className="rounded-circle me-2"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: COLORS.Sketch,
                }}
              ></div>
              <span className="text-muted small">Sketch</span>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default GoalsMetChart;
